// extracted by mini-css-extract-plugin
module.exports = {"base":"AppName_base__1mi7i"};